import React from 'react';
import PropTypes from 'prop-types';
import './ChatOptions.scss';

const ChatOptions = ({ options, onSelect }) => {
  if (!options || options.length === 0) return null;

  return (
    <div className="chat-options">
      {options.map((option) => (
        <button
          key={option.id}
          className={`chat-options__item ${
            option.primary ? 'chat-options__item--primary' : ''
          }`}
          onClick={() => onSelect(option)}
        >
          {option.icon && (
            <span className="material-symbols-rounded">{option.icon}</span>
          )}
          <span className="chat-options__label">{option.label}</span>
        </button>
      ))}
    </div>
  );
};

ChatOptions.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      primary: PropTypes.bool,
    }),
  ).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default ChatOptions;
